import React, { useEffect } from "react";
import { Wrapper } from "./ForgotPassword.styled";
import ForgetPassword from "components/pageSection/ForgetPassword/ForgetPassword";

const ForgotPassword = () => {
  return (
    <Wrapper>
      <div className="forgot-password">
        <ForgetPassword />
      </div>
    </Wrapper>
  );
};

export default ForgotPassword;
